import Button, { ButtonProps } from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import React, { forwardRef, useMemo } from "react";
import { Icons } from "atoms/constants/icons";
import { useLocalization } from "utilities/hooks/use-localization";
import PageRecord from "models/view-models/page-record";
import useCurrentNotebook from "utilities/hooks/domain/notebooks/use-current-notebook";
import { useGlobalState } from "utilities/contexts/use-global-state-context";

export interface EditPageMenuItemProps extends ButtonProps {
    page: PageRecord;
    onClick: () => void;
}
const CSS_CLASS_NAME = "c-page-context-menu";

const EditPageMenuItem = forwardRef<HTMLButtonElement, EditPageMenuItemProps>(
    (props, ref) => {
        const { page, onClick, children, ...rest } = props;
        const { t } = useLocalization();

        const { globalState } = useGlobalState();
        const { currentNotebook } = useCurrentNotebook();

        const canEdit = useMemo(() => {
            const userId = globalState?.currentIdentity?.userId();

            return (
                userId === page.ownerId || userId === currentNotebook?.ownerId
            );
        }, [
            globalState?.currentIdentity,
            page.ownerId,
            currentNotebook?.ownerId,
        ]);

        return (
            <>
                {canEdit && (
                    <Button
                        ref={ref}
                        accessibleText={t("editItem", {
                            item: t("page"),
                        })}
                        cssClassName={`${CSS_CLASS_NAME}__button`}
                        onClick={onClick}
                        {...rest}
                        dataTestId="notebook-page--page-context-menu--edit-page-button">
                        <Icon type={Icons.Pencil} />
                        {t("editItem", {
                            item: t("page"),
                        })}
                    </Button>
                )}
            </>
        );
    }
);

export default EditPageMenuItem;
